import React from "react";
import { View, StyleSheet, Text } from "react-native";

export const AddGroupScreen = () => {
  return (
    <View style={styles.container}>
      <Text>ADD GROUP SCREEN</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
